import React from "react";
import classNames from "classnames";
import { Button } from "@design-system/Button/Button";
import styles from "./EmptyState.module.scss";

interface EmptyStateProps {
    header: string;
    body?: React.ReactNode;
    ctaText?: React.ReactNode;
    action?: () => void;
    buttonVariant?: "primary" | "secondary";
    secondaryCtaText?: React.ReactNode;
    secondaryAction?: () => void;
    secondaryButtonVariant?: "primary" | "secondary";
    cta?: React.ReactNode;
    emphasizeHeader?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    header,
    body,
    ctaText = "Clear filters",
    action,
    buttonVariant = "primary",
    secondaryCtaText,
    secondaryAction,
    secondaryButtonVariant = "secondary",
    cta,
    emphasizeHeader = true,
}) => {
    const hasPrimaryCta = !!ctaText && !!action;
    const hasSecondaryCta = !!secondaryCtaText && !!secondaryAction;
    const hasCta = !!cta || hasPrimaryCta || hasSecondaryCta;

    return (
        <section className={styles.emptyState}>
            <header
                className={classNames(styles.header, {
                    [styles.emphasized]: emphasizeHeader,
                })}
            >
                {header}
            </header>
            {body && <p className={styles.body}>{body}</p>}
            {hasCta ? (
                <footer className={styles.cta}>
                    {cta ?? (
                        <>
                            {hasPrimaryCta ? (
                                <Button
                                    variant={buttonVariant}
                                    size="md"
                                    onClick={action}
                                >
                                    {ctaText}
                                </Button>
                            ) : null}
                            {hasSecondaryCta ? (
                                <Button
                                    variant={secondaryButtonVariant}
                                    size="md"
                                    onClick={secondaryAction}
                                >
                                    {secondaryCtaText}
                                </Button>
                            ) : null}
                        </>
                    )}
                </footer>
            ) : null}
        </section>
    );
};
